(function () {
  const SHIPPING_COST = 0;

  const els = {
    cartItems: document.getElementById('cart-items'),
    subtotal: document.getElementById('subtotal'),
    shipping: document.getElementById('shipping'),
    total: document.getElementById('total'),
    confirmBtn: document.getElementById('confirm-order-btn'),
  };

  if (!els.cartItems || !els.subtotal || !els.shipping || !els.total || !els.confirmBtn) {
    return;
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value || 0);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito');
    }
    return await response.json();
  }

  function renderCartItems(cart) {
    const items = cart.items || [];

    if (items.length === 0) {
      els.cartItems.innerHTML =
        '<div class="empty-cart">' +
        '<div class="empty-cart__icon">🛒</div>' +
        '<h3 class="empty-cart__title">Tu carrito está vacio</h3>' +
        '<p class="empty-cart__text">No hay productos agregados.</p>' +
        '<a href="/#catalogo" class="empty-cart__link">Volver al catalogo</a>' +
        '</div>';
      return;
    }

    els.cartItems.innerHTML = items
      .map((item) => {
        const image = item.image || '';
        const unitPrice = (item.price || 0) / 100;
        const linePrice = (item.final_line_price || 0) / 100;
        const variant = item.variant_title || 'Variante predeterminada';

        return (
          '<div class="cart-item">' +
          '<div class="cart-item__image">' +
          (image ? '<img src="' + image + '" alt="' + item.product_title + '">' : '') +
          '</div>' +
          '<div class="cart-item__content">' +
          '<h4 class="cart-item__name">' + item.product_title + '</h4>' +
          '<div class="cart-item__specs">' +
          '<span class="cart-item__spec">Variante: ' + variant + '</span>' +
          '</div>' +
          '<div class="cart-item__pricing">' +
          '<div class="cart-item__price-row">' +
          '<span class="cart-item__label">Precio unitario:</span>' +
          '<span class="cart-item__price">' + formatPrice(unitPrice) + '</span>' +
          '</div>' +
          '<div class="cart-item__price-row">' +
          '<span class="cart-item__label">Cantidad:</span>' +
          '<span class="cart-item__quantity">' + item.quantity + '</span>' +
          '</div>' +
          '<div class="cart-item__price-row cart-item__price-row--total">' +
          '<span class="cart-item__label">Subtotal:</span>' +
          '<span class="cart-item__total">' + formatPrice(linePrice) + '</span>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '<span class="cart-item__badge">' + item.quantity + '</span>' +
          '</div>'
        );
      })
      .join('');
  }

  function calculateTotals(cart) {
    const subtotal = (cart.total_price || 0) / 100;
    const shipping = SHIPPING_COST;
    const total = subtotal + shipping;

    els.subtotal.textContent = formatPrice(subtotal);
    els.shipping.textContent = shipping === 0 ? '¡Gratis!' : formatPrice(shipping);
    els.total.textContent = formatPrice(total);

    return { subtotal, shipping, total };
  }

  async function handleConfirmOrder() {
    let cart;
    try {
      cart = await fetchCart();
    } catch {
      alert('No se pudo cargar el carrito. Intenta de nuevo.');
      return;
    }

    if (!cart.items || cart.items.length === 0) {
      alert('Tu carrito esta vacio.');
      return;
    }

    globalThis.location.href = '/checkout';
  }

  async function init() {
    try {
      const cart = await fetchCart();
      renderCartItems(cart);
      calculateTotals(cart);
    } catch {
      els.cartItems.innerHTML = '<p>No se pudo cargar el carrito.</p>';
    }

    els.confirmBtn.addEventListener('click', handleConfirmOrder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
